import { GENERIC_CONSTANT } from './constants'

export const editArticle = (articleNumber, articleId) => {
  window.open(
    `${GENERIC_CONSTANT.dato_cms_url}/${articleNumber}/items/${articleId}/edit`,
    '_blank',
  )
}
